export default {"src":"/_next/static/media/warning_24.ddbd14ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};